import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import './styles.css';
import Quiz from './components/Quiz';
import Form from './components/Form';
import Privacy from './components/Privacy';
import Terms from './components/Terms';

// Placeholder CTA page - to be implemented
function CTAPage() {
  return (
    <div className="container text-center">
      <div className="card">
        <h1>Thank You!</h1>
        <p>Your information has been submitted successfully.</p>
        <p>Our team will contact you within 2 hours.</p>
        <p className="text-secondary">Check your email for confirmation.</p>
      </div>
    </div>
  );
}

function DisqualifiedPage() {
  const reason = sessionStorage.getItem('disqualifyReason');
  return (
    <div className="container text-center">
      <div className="card">
        <h1>We're Sorry</h1>
        <p>Based on your responses, we may not be able to help with your case at this time.</p>
        <p className="text-secondary">Reason: {reason}</p>
        <p>However, we recommend consulting with a local attorney to discuss your options.</p>
        <Link to="/" className="btn btn-primary" style={{ marginTop: '20px', display: 'inline-block' }}>
          Start Over
        </Link>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        {/* Sticky Phone CTA Header */}
        <header className="header-cta">
          <p className="header-cta-text">
            <span className="cta-icon">📞</span>
            <strong>Call Now to Speak with a Lawyer:</strong>
            <a href="tel:+18445221358" className="header-phone-link">(844) 522-1358</a>
          </p>
        </header>

        <Routes>
          <Route path="/" element={<Quiz />} />
          <Route path="/form" element={<Form />} />
          <Route path="/cta" element={<CTAPage />} />
          <Route path="/disqualified" element={<DisqualifiedPage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>

        <footer className="footer">
          {/* Trust Signals */}
          <div className="footer-trust" style={{marginBottom: '16px'}}>
            <p className="trust-text">
              <span className="icon-lock"></span>
              SSL Encrypted | Your information is secure
            </p>
            <p className="trust-text">
              <span className="icon-lightning"></span>
              Fast Response | Average reply under 2 hours
            </p>
          </div>

          {/* Phone - Bold Blue Link */}
          <a href="tel:+18445221358" className="footer-phone">
            <span className="icon-phone"></span>
            (844) 522-1358
          </a>

          {/* Footer Links */}
          <div className="footer-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>

          {/* Copyright */}
          <p className="footer-text">
            &copy; 2025 ClaimYourCrash.com | All Rights Reserved
          </p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
